module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-62429b4d.png";